import { useContext } from 'react';
import TranslationContext from './TranslationContext';
export default function useTranslation() {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { locales, ...rest } = useContext(TranslationContext);
    return rest;
}
